import React, { Fragment, useEffect } from "react";
import AvatarWithName from "@/components/AvatarWithName";
import { getRelativeTime } from "@/utils/datetime";

import { DEFAULT_IMAGE_CARD } from "@/constants/image";
import dynamic from "next/dynamic";
import { useState, useContext } from "react";
import FormReplyReview from "@/modules/common/ProjectDetail/ReviewItem/ListReplyReview/FormReplyReview";
import ReviewDetailRate from "@/modules/common/ProjectDetail/ReviewItem/ReviewDetailRate";
import ReviewDetailTextContent from "@/modules/common/ProjectDetail/ReviewItem/ReviewDetailTextContent";
import { CommentTypeEnum } from "@/constants/enum/comment";
import clsx from "clsx";
import ShareButton from "@components/Share";
import { APP_BASE_URL } from "@/constants/environment";
import ModalViewDetailFile from "@/modules/Desktop/ProjectDetail/RightContent/ModalViewDetailFile";
import ModalViewDetailFileMobile from "@/modules/Mobile/ProjectDetailMobile/RightContent/ModalViewDetailFile";
import { ProjectContext } from "@/context/project.context";
import { useRouter } from "next/router";
import urlJoin from "url-join";
import { DeviceContext } from "@/context/device.context";
import BoxReply from "@/modules/common/ProjectDetail/ReviewItem/BoxReply";
import PopOver from "@/components/PopOver";
import { useAuth } from "@/hooks/useAuth";
import ReportModal from "../ProjectDetail/ReviewItem/ReportModal";

const ListReplyReview = dynamic(
  import("@/modules/common/ProjectDetail/ReviewItem/ListReplyReview"),
  { ssr: false }
);

const ReviewDetailFileList = dynamic(
  import("@/modules/common/ProjectDetail/ReviewItem/ReviewDetailFileList"),
  {
    ssr: false,
  }
);
const ReviewDetailAction = dynamic(
  import("@/modules/common/ProjectDetail/ReviewItem/ReviewDetailAction"),
  {
    ssr: false,
  }
);

let timeOutBachground: NodeJS.Timeout = null;

const ReviewInfo = ({ reviewDetail }: any) => {
  const {
    selectedViewFiles,
    currentShowFormReply,
    setCurrentShowFormReport,
    currentRefItem,
  } = useContext(ProjectContext);

  const { user, login } = useAuth();
  const [mounted, setMounted] = useState(false);
  const {
    query: { id },
    asPath,
  } = useRouter();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      const reviewElement = document.getElementById(`${id}`);
      if (reviewElement) {
        reviewElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        reviewElement.style.background = "#EBF3FC";
        if (timeOutBachground) clearTimeout(timeOutBachground);
        timeOutBachground = setTimeout(() => {
          reviewElement.style.background = "unset";
        }, 2000);
      }
    }
  }, [mounted]);

  const { isMobile } = useContext(DeviceContext);
  return reviewDetail.map((data, index) => {
    return (
      <Fragment key={data._id}>
        <ReportModal />
        <div
          style={{
            boxShadow:
              "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)",
          }}
          ref={(ele: HTMLDivElement) => {
            currentRefItem.current[index] = ele;
          }}
          className="gap-x-3 p-4 bg-white md:rounded-xl w-full overflow-auto border-b border-b-gray-200">
          <div className="w-full first-letter:gap-x-3 overflow-auto">
            <div
              className="flex items-start gap-x-3 duration-300"
              id={data._id}>
              <AvatarWithName
                imageClass="md:!w-14 md:!h-14 !w-8 !h-8"
                imageProps={{ resizeOnFly: false }}
                className="flex-[0_0_auto]"
                avatarOnly
                alt={data?.nickName ?? "Ẩn danh"}
                name={data?.nickName}
                src={
                  data?.createdBy?.avatar
                    ? data?.createdBy?.avatar
                    : data?.nickName
                    ? null
                    : DEFAULT_IMAGE_CARD
                }
              />
              <div className="flex-[1_1_auto] overflow-auto">
                <div className="flex justify-between w-full">
                  <div className="text-grey-700 font-semibold md:flex items-center flex-1 justify-start table-cell align-middle">
                    <span className="md:line-clamp-1 break-word align-middle">
                      {data.nickName ? data.nickName : "Ẩn danh"}{" "}
                    </span>

                    <span className="ml-1.5 text-grey-600 text-fs-14 font-normal whitespace-nowrap align-middle">
                      {data.type === CommentTypeEnum.REVIEW
                        ? "đã viết review"
                        : "đã đặt câu hỏi"}
                    </span>
                    <i
                      className={clsx(
                        "mrv  text-fs-24 text-grey-400  ml-1.5 cursor-pointe flex-0 align-middle",
                        data.type === CommentTypeEnum.REVIEW
                          ? "mrv-review"
                          : "mrv-contact_support"
                      )}></i>
                  </div>
                  <div className="flex-0 flex gap-2">
                    <ShareButton shareUrl={urlJoin(APP_BASE_URL, asPath)}>
                      <i className="mrv mrv-share text-fs-24 ml-1.5 cursor-pointer"></i>
                    </ShareButton>
                    <PopOver
                      dropdownClassName="px-2 py-2.5 rounded-lg shadow-light-2"
                      content={
                        <div>
                          <div
                            className="flex items-center w-56 cursor-pointer"
                            onClick={() =>
                              user
                                ? setCurrentShowFormReport(data._id)
                                : login()
                            }>
                            <i className="mrv mrv-report text-fs-20 mr-2 cursor-pointer"></i>
                            Báo cáo bài viết
                          </div>
                        </div>
                      }>
                      <i className="mrv mrv-more_vert text-fs-24 ml-1.5 cursor-pointer"></i>
                    </PopOver>
                  </div>
                </div>
                <div className="text-grey-500 text-fs-14">
                  {getRelativeTime(new Date(data?.publishedAt))}
                </div>

                <div className="w-full overflow-auto">
                  <ReviewDetailRate data={data} />
                  <ReviewDetailTextContent data={data} />
                  <ReviewDetailFileList data={data} />
                  <ReviewDetailAction data={data} />
                  {currentShowFormReply ? null : <BoxReply data={data} />}
                  {currentShowFormReply == data._id ? (
                    <FormReplyReview
                      data={data}
                      reviewItem={data}
                      reviewIndex={index}
                    />
                  ) : null}
                </div>
              </div>
            </div>

            <div className="ml-14 reply-review-list">
              {<ListReplyReview reviewIndex={index} data={data} />}
            </div>
          </div>
        </div>
        {selectedViewFiles?.currentFile ? (
          isMobile ? (
            <ModalViewDetailFileMobile />
          ) : (
            <ModalViewDetailFile />
          )
        ) : null}
      </Fragment>
    );
  });
};

export default ReviewInfo;
